import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from '../../../model';

const { stepChangeAction } = actions;

const GoToStep = ({ component: Component, selector, toStep, ...props }) => {
  const canGoTo = useSelector(selector);

  const dispatch = useDispatch();

  const handleClick = () => dispatch(stepChangeAction(toStep));

  return (
    <Component
      {...props}
      disabled={!canGoTo}
      onClick={handleClick}
    />
  );
};

export default GoToStep;
